import { defineStore } from 'pinia'
import {ref, computed} from 'vue'


export const use98Store = defineStore(
	"nine8",
	() => {
		const nine8 = ref(false)
		// const ninety_eight = ref(false)
	},
)